import { Icon } from '@iconify/react';
import style from './sort-btn.module.scss';

const SortBtn = ({ children, onClick }) => {
    return (
        children && (
            <button type='button' className={style.sort_btn} onClick={onClick}>
                <span>{children}</span>
                <Icon icon="uil:sorting" fontSize="1.25rem" className={style.icon} />
            </button>
        )
    );
};

export default SortBtn;
